module.exports = __webpack_public_path__ + "img/1567843532.14a096d3.jpg";